import {t} from "@lingui/core/macro";
import {useContext} from "react";

import IconButton from "@khanacademy/wonder-blocks-icon-button";
import Tooltip from "@khanacademy/wonder-blocks-tooltip";
import {useGuideState} from "@khan/guide-state";
import {AppShellContext} from "@khan/shared-core/context";

import atIcon from "@phosphor-icons/core/regular/at.svg";

type AtIconButtonType = React.FunctionComponent<{
    disabled?: boolean;
    onClick?: () => void;
    title?: string;
    isMobile: boolean;
}>;

const AtIconButton: AtIconButtonType = ({
    disabled,
    onClick,
    title,
    isMobile,
}): React.ReactElement => {
    const activityPersona = useGuideState("activityPersona");
    const {entrypoint} = useContext(AppShellContext);
    const iconSize = entrypoint === "classroom" ? "medium" : "small";

    const icon = (
        <IconButton
            aria-label={title}
            disabled={disabled}
            icon={atIcon}
            kind="tertiary"
            actionType="neutral"
            onClick={onClick}
            size={iconSize}
            testId="at-icon-button"
        />
    );
    const tooltipText =
        activityPersona === "PARENT" ? t`Mention child` : t`Mention student`;
    return !isMobile ? (
        <Tooltip
            content={tooltipText}
            forceAnchorFocusivity={false}
            placement="bottom"
            testId="at-icon-tooltip"
        >
            {icon}
        </Tooltip>
    ) : (
        icon
    );
};
export {AtIconButton};
